exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ss-cmpts-acct-popo-container {\n  width: 120px;\n  margin: -5px -5px 5px;\n}\n.ss-cmpts-acct-popo-card {\n  textAlign: center;\n  width: 100%;\n  background: #fff;\n  border-radius: 4px;\n  border-color: white;\n  border-style: solid;\n  overflow: hidden;\n  margin: -13px 0px;\n}\n.ss-cmpts-acct-popo-btn-container {\n  color: #595959;\n}\n", ""]);

